import { filterWorkbenchItems } from '../config/newUiPermissions'

export default {
  methods: {
    newUiVisibleItems(workbenchId, items) {
      const login = this.$store.state.login
      const userinfo = login.userinfo || {}
      return filterWorkbenchItems(workbenchId, items, userinfo.new_ui_access, login.is_host)
    }
  }
}
